import { useTranslations } from 'next-intl'
import type { Editor } from '@tiptap/react'
import type { FormatAction } from '../../types'
import type { toggleVariants } from '@/components/ui/toggle'
import type { VariantProps } from 'class-variance-authority'
import { ToolbarSection } from '../toolbar-section'
import {
  AlignCenter,
  AlignJustify,
  AlignLeft,
  AlignRight,
  ChevronDown,
  List,
} from 'lucide-react'

type ListItemAction =
  | 'textAlignLeft'
  | 'textAlignCenter'
  | 'textAlignRight'
  | 'textAlignjustify'
interface ListItem extends FormatAction {
  value: ListItemAction
}

const formatActions: ListItem[] = [
  {
    value: 'textAlignLeft',
    label: 'text_align_left',
    icon: <AlignLeft className="size-5" />,
    isActive: (editor) => editor.isActive({ textAlign: 'left' }),
    action: (editor) => editor.chain().focus().setTextAlign('left').run(),
    canExecute: (editor) =>
      editor.can().chain().focus().toggleTextAlign('left').run(),
    shortcuts: [],
  },
  {
    value: 'textAlignRight',
    label: 'text_align_right',
    icon: <AlignRight className="size-5" />,
    isActive: (editor) => editor.isActive({ textAlign: 'right' }),
    action: (editor) => editor.chain().focus().setTextAlign('right').run(),
    canExecute: (editor) =>
      editor.can().chain().focus().toggleTextAlign('right').run(),
    shortcuts: [],
  },
  {
    value: 'textAlignCenter',
    label: 'text_align_center',
    icon: <AlignCenter className="size-5" />,
    isActive: (editor) => editor.isActive({ textAlign: 'center' }),
    action: (editor) => editor.chain().focus().setTextAlign('center').run(),
    canExecute: (editor) =>
      editor.can().chain().focus().toggleTextAlign('center').run(),
    shortcuts: [],
  },
  {
    value: 'textAlignjustify',
    label: 'text_align_justify',
    icon: <AlignJustify className="size-5" />,
    isActive: (editor) => editor.isActive({ textAlign: 'justify' }),
    action: (editor) => editor.chain().focus().setTextAlign('justify').run(),
    canExecute: (editor) =>
      editor.can().chain().focus().toggleTextAlign('justify').run(),
    shortcuts: [],
  },
]

const createFormatActions = (t: any) => {
  return formatActions.map((d) => ({
    ...d,
    label: t(d.label),
  }))
}

interface SectionFiveProps extends VariantProps<typeof toggleVariants> {
  editor: Editor
  activeActions?: ListItemAction[]
  mainActionCount?: number
  modal?: boolean
}

export const SectionFive: React.FC<SectionFiveProps> = ({
  editor,
  activeActions = formatActions.map((action) => action.value),
  mainActionCount = 0,
  size,
  variant,
  modal,
}) => {
  const t = useTranslations('tiptap')
  const intlFormatActions = createFormatActions(t)
  return (
    <ToolbarSection
      editor={editor}
      actions={intlFormatActions}
      activeActions={activeActions}
      mainActionCount={mainActionCount}
      dropdownIcon={
        <>
          <AlignLeft className="size-5" />
          <ChevronDown className="size-5" />
        </>
      }
      dropdownTooltip={t('textAlign')}
      size={size}
      variant={variant}
    />
  )
}

SectionFive.displayName = 'SectionFive'

export default SectionFive
